(() => {
  'use strict';

  const p2 = window.CoastalSoulP2;
  if (!p2) return;

  const {
    normalize,
    getMain,
    replaceText,
    setLinks,
    findTextElement,
    setCardCopy,
    replaceDuplicateQuestionForm,
    insertJoinCta,
    ensureCatalogList
  } = p2;

  const replaceExactElementText = (
    root,
    from,
    to,
    selector = 'h1, h2, h3, h4, h5, p, a, button, span'
  ) => {
    const target = normalize(from).toLowerCase();
    let changed = 0;

    root.querySelectorAll(selector).forEach((element) => {
      if (
        element.children.length === 0 &&
        normalize(element.textContent).toLowerCase() === target
      ) {
        element.textContent = to;
        changed += 1;
      }
    });

    return changed;
  };

  const patchHomepageNewsletter = (root) => {
    const newsletter =
      root.querySelector('[id$="__1655112847aaa4cc50"]') ||
      findTextElement(root, 'newsletter', 'h1, h2, h3, h4, p')?.closest(
        '[id^="shopify-section-"], section'
      );
    if (!newsletter) return;

    newsletter
      .querySelectorAll('button, input[type="submit"]')
      .forEach((control) => {
        const text = normalize(
          control.tagName === 'INPUT' ? control.value : control.textContent
        ).toLowerCase();

        if (text === 'submit') {
          if (control.tagName === 'INPUT') control.value = 'Join the Table';
          else control.textContent = 'Join the Table';
          control.setAttribute('aria-label', 'Join the Table');
        }
      });
  };

  const patchHome = (root) => {
    if (root.querySelector('.marvin-homepage')) return;

    replaceText(root, 'E-RECIPES', 'Digital Recipe Collections');
    replaceText(root, 'ELECTRONIC RECIPES', 'Digital Recipe Collections');
    replaceText(root, '100% Organic Food', 'Whole Ingredients. Bold Flavor.');
    replaceExactElementText(root, '100%', 'Whole Ingredients.');
    replaceExactElementText(root, 'Organic Food', 'Bold Flavor.');
    patchHomepageNewsletter(root);

    setCardCopy(root, 'Bowl Life', {
      summary:
        'Build balanced, deeply flavorful bowls from the grain up using Chef Marvin Woods’ six-layer Foodology method: base, body, greens, protein, sauce, and finish.',
      heading: 'What you’ll learn',
      bullets: [
        'Cook Carolina Gold rice, fonio, chickpea rice, and lentils with the right technique.',
        'Use braised, wilted, and raw greens to create balance, texture, and contrast.',
        'Build sauces and finishes that tie every layer together.',
        'Batch grains, proteins, and sauces for easier bowl assembly throughout the week.'
      ]
    });

    setCardCopy(root, 'After Dark', {
      summary:
        'Nine complete Coastal Soul dinners for weeknights, date nights, and family meals, with step-by-step instruction, shopping lists, equipment recommendations, chef techniques, and Foodology insights.',
      heading: 'What you’ll learn',
      bullets: [
        'Build layered flavor with seasoning, aromatics, acid, and fat.',
        'Cook Carolina Gold rice and fonio, braise vegetables, and build stocks and broths.',
        'Roast, sear, and glaze proteins to a restaurant-quality finish.',
        'Improve mise en place, timing, sequencing, and confidence adapting recipes at home.'
      ]
    });
  };

  const patchCoastalSoul = (root) => {
    replaceText(root, '27 years', 'more than four decades');
    replaceText(root, 'Featured: The Spice Series', 'The Receipts');
    replaceText(root, 'Frederick Mckinnley Jones', 'Frederick McKinley Jones');
    replaceText(root, 'Peoples Grocery', 'People’s Grocery');
    replaceText(root, 'Columbo Dust', 'Colombo Dust');

    const lowcountryParagraphs = Array.from(root.querySelectorAll('p')).filter(
      (paragraph) => {
        const text = normalize(paragraph.textContent).toLowerCase();
        return (
          text.includes(
            'in the lowcountry, these cooking practices formed what we now know as gullah geechee foodways'
          ) ||
          (text.includes('gullah geechee foodways') &&
            text.includes('charleston red rice'))
        );
      }
    );
    lowcountryParagraphs.slice(1).forEach((paragraph) => paragraph.remove());

    const receiptsHeading = findTextElement(
      root,
      'The Receipts',
      'h1, h2, h3, h4, h5, strong'
    );
    if (receiptsHeading && !receiptsHeading.closest('a')) {
      const anchor = document.createElement('a');
      anchor.href = '/pages/receipts-watch-videos';
      anchor.textContent = normalize(receiptsHeading.textContent);
      receiptsHeading.replaceChildren(anchor);
    }
    setLinks(root, ['The Receipts'], '/pages/receipts-watch-videos');
  };

  const patchBundles = (root) => {
    replaceDuplicateQuestionForm(root, 'bundles');
    ensureCatalogList(root);
  };

  const patchAbout = (root) => {
    replaceText(root, 'more than 25 years', 'more than four decades');
    replaceDuplicateQuestionForm(root, 'about');
    setLinks(root, ['Explore Coastal Soul'], '/pages/coastal-soul');
  };

  const patchWatch = (root) => {
    replaceText(root, 'Forty years', 'More than four decades');
    replaceText(
      root,
      'Frederick McKinley Episode 3',
      'Frederick McKinley Jones — Episode 3'
    );

    const showSentence = Array.from(root.querySelectorAll('p, div')).find(
      (element) => {
        const text = normalize(element.textContent).toLowerCase();
        return (
          text.startsWith('two shows') &&
          text.includes('one mission') &&
          element.children.length < 5
        );
      }
    );
    if (showSentence) {
      showSentence.textContent =
        'Two shows, one mission. The Receipts, for the table — and for the kids who’ll set it next, The Culinary Capers of Bandana Boy.';
    }

    insertJoinCta(root, 'watch');
  };


  const patchAtTheTable = (root) => {
    const questionSection = root.querySelector('#ask-chef-marvin');
    if (!questionSection) return;

    const formWrap = questionSection.querySelector('[class*="att__form-wrap-"]');
    if (!formWrap) return;

    const cleanFormCopy = () => {
      formWrap.querySelector('[class*="att__form-heading-"]')?.remove();

      const roots = [formWrap];
      for (let index = 0; index < roots.length; index += 1) {
        roots[index].querySelectorAll?.('*').forEach((element) => {
          if (element.shadowRoot && !roots.includes(element.shadowRoot)) {
            roots.push(element.shadowRoot);
          }
        });
      }

      const duplicateText = new Set([
        'share your question',
        'just real answers that make you a better cook.'
      ]);

      roots.forEach((currentRoot) => {
        currentRoot
          .querySelectorAll?.('h1, h2, h3, h4, h5, h6, p, span, div')
          .forEach((element) => {
            const text = normalize(element.textContent).toLowerCase();
            if (!duplicateText.has(text)) return;

            const containsControl = Boolean(
              element.querySelector(
                'form, input, textarea, select, button, iframe, [role="form"]'
              )
            );
            const childRepeatsText = Array.from(element.children || []).some(
              (child) =>
                duplicateText.has(normalize(child.textContent).toLowerCase())
            );

            if (!containsControl && !childRepeatsText) {
              element.hidden = true;
              element.style.setProperty('display', 'none', 'important');
              element.setAttribute('aria-hidden', 'true');
            }
          });

        currentRoot
          .querySelectorAll?.('button, input[type="submit"]')
          .forEach((control) => {
            const label = normalize(
              control.tagName === 'INPUT' ? control.value : control.textContent
            ).toLowerCase();

            if (label !== 'join the table' && label !== 'join the table!') {
              return;
            }

            if (control.tagName === 'INPUT') {
              control.value = 'Submit Question';
            } else {
              const textElement = control.querySelector('span');
              if (textElement) textElement.textContent = 'Submit Question';
              else control.textContent = 'Submit Question';
            }
            control.setAttribute('aria-label', 'Submit Question');
          });
      });
    };

    cleanFormCopy();

    if (questionSection.dataset.p2FormCleanupStarted === 'true') return;
    questionSection.dataset.p2FormCleanupStarted = 'true';

    const observer = new MutationObserver(cleanFormCopy);
    observer.observe(formWrap, { childList: true, subtree: true });

    let attempts = 0;
    const timer = window.setInterval(() => {
      cleanFormCopy();
      attempts += 1;
      if (attempts >= 48) window.clearInterval(timer);
    }, 250);
  };

  const run = () => {
    const root = getMain();
    const path = window.location.pathname.replace(/\/$/, '') || '/';

    if (path === '/') patchHome(root);
    if (path === '/pages/coastal-soul') patchCoastalSoul(root);
    if (path === '/pages/bundles') patchBundles(root);
    if (path === '/pages/about') patchAbout(root);
    if (path === '/pages/receipts-watch-videos') patchWatch(root);
    if (path === '/pages/at-the-table') patchAtTheTable(root);
  };

  const schedule = () => window.requestAnimationFrame(run);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('shopify:section:load', schedule);
})();
